const fontSmoothing = {
  name: "font-smoothing",
  path: "/font-smoothing",
  title: "font-smoothing",
  description: "Utilities for controlling font smoothing (antialiasing) of text.",
  value: {
    "-webkit-font-smoothing": {
      'antialiased': 'antialiased',
      'subpixel-antialiased': 'auto',
    }
  },
  exampleData: [
    {
      example: {
        code: `
<p class="antialiased text-lg">The quick brown fox jumps over the lazy dog. (antialiased)</p>
<p class="subpixel-antialiased text-lg">The quick brown fox jumps over the lazy dog. (subpixel-antialiased)</p>
        `
      }
    }
  ],
  htmlData: [
    {
      data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">antialiased</code> or <code class="text-color-gray-800 dark:text-color-white font-semibold">subpixel-antialiased</code> to control font smoothing:
      </p>
      <div class="space-y-6">
        <div>
            <small class="mb-3 font-mono font-medium  text-color-gray-500 dark:text-color-gray-400">antialiased</small>
            <p class="antialiased text-lg">The quick brown fox jumps over the lazy dog.</p>
        </div>
        <div>
            <small class="mb-3 font-mono font-medium  text-color-gray-500 dark:text-color-gray-400">subpixel-antialiased</small>
            <p class="subpixel-antialiased text-lg">The quick brown fox jumps over the lazy dog.</p>
        </div>
      </div>
      `
    }
  ]
};

export default fontSmoothing;

<div className="antialiased ubpixel-antialiased"> </div>